"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

function getLevelSuffix(isFirstLevel, isLastLevel) {
  if (isFirstLevel) return 'first-level';
  if (isLastLevel) return 'last-level';
  return 'middle-level';
}

function hasSelectedChildren(children, ids) {
  var hasSelectedChildren = false;

  for (var i = 0; i < children.length; ++i) {
    if (ids.includes(String(children[i].id))) {
      hasSelectedChildren = true;
      break;
    }
  }

  return hasSelectedChildren;
}

var NestedDropdown = function NestedDropdown(_ref) {
  var items = _ref.items,
      onSelectItem = _ref.onSelectItem,
      onMultiSelect = _ref.onMultiSelect,
      onToggleCollapse = _ref.onToggleCollapse,
      depth = _ref.depth,
      selectedItems = _ref.selectedItems,
      _ref$isCollapsed = _ref.isCollapsed,
      isCollapsed = _ref$isCollapsed === void 0 ? false : _ref$isCollapsed,
      isCategoryDropdown = _ref.isCategoryDropdown,
      showBothCheckboxAndCollapse = _ref.showBothCheckboxAndCollapse,
      labelId = _ref.labelId;
  return (0, _preact.h)("div", {
    role: "tree"
  }, items.map(function (item) {
    var _ref2 = item || {},
        id = _ref2.id,
        title = _ref2.title,
        children = _ref2.children,
        _ref2$isCollapsed = _ref2.isCollapsed,
        collapsed = _ref2$isCollapsed === void 0 ? false : _ref2$isCollapsed,
        imageUrl = _ref2.imageUrl;

    var hasChildren = children.length > 0;
    var isFirstLevel = depth === 1;
    var isLastLevel = !hasChildren;
    var levelSuffix = getLevelSuffix(isFirstLevel, isLastLevel);
    var hasCheckedChildren = selectedItems ? hasSelectedChildren(children, selectedItems) : false;
    var isChecked = Boolean(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.includes(String(id))) || hasCheckedChildren; // Select item handler (for leaf items without multiselect)

    var handleItemClick = function handleItemClick() {
      onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(id);
    };

    var handleItemKeyDown = function handleItemKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onSelectItem === null || onSelectItem === void 0 ? void 0 : onSelectItem(id);
      }
    }; // Multiselect handlers (stopPropagation keeps dropdown open for multi-selection)


    var handleMultiSelectClick = function handleMultiSelectClick(e) {
      e.stopPropagation();
      onMultiSelect === null || onMultiSelect === void 0 ? void 0 : onMultiSelect(id, !isChecked);
    };

    var handleMultiSelectKeyDown = function handleMultiSelectKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        onMultiSelect === null || onMultiSelect === void 0 ? void 0 : onMultiSelect(id, !isChecked);
      }
    }; // Collapse button handlers


    var handleCollapseClick = function handleCollapseClick(e) {
      e.stopPropagation();
      onToggleCollapse === null || onToggleCollapse === void 0 ? void 0 : onToggleCollapse(id);
    };

    var handleCollapseKeyDown = function handleCollapseKeyDown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        onToggleCollapse === null || onToggleCollapse === void 0 ? void 0 : onToggleCollapse(id);
      }
    };

    return (0, _preact.h)("div", {
      key: id,
      className: (0, _classnames.default)('dropdown-selector__item-wrapper', isFirstLevel && 'dropdown-selector__item-wrapper--first-level', !hasChildren && 'dropdown-selector__item-wrapper--no-children', isCollapsed ? 'dropdown-selector__item-wrapper--collapsed' : 'dropdown-selector__item-wrapper--expanded'),
      role: hasChildren ? 'treeitem' : undefined,
      "aria-expanded": hasChildren ? !collapsed : undefined
    }, (0, _preact.h)("li", {
      className: (0, _classnames.default)('dropdown-selector__item', "dropdown-selector__item--".concat(levelSuffix), "dropdown-selector__item--".concat(levelSuffix).concat(isCategoryDropdown ? '--category-selection' : ''), !hasChildren && 'dropdown-selector__item--no-children', onMultiSelect && 'dropdown-selector__item__multi-select'),
      "data-value": id,
      style: {
        paddingLeft: "".concat(depth * 16, "px")
      },
      role: onMultiSelect ? 'checkbox' : hasChildren ? 'none' : 'button',
      "aria-checked": onMultiSelect ? isChecked : undefined,
      tabIndex: hasChildren && !onMultiSelect ? -1 : 0,
      onClick: onMultiSelect ? handleMultiSelectClick : !hasChildren ? handleItemClick : handleCollapseClick,
      onKeyDown: onMultiSelect ? handleMultiSelectKeyDown : !hasChildren ? handleItemKeyDown : undefined
    }, onMultiSelect ? (0, _preact.h)("div", {
      className: "dropdown-selector__item__multi-select-content"
    }, (0, _preact.h)("input", {
      type: "checkbox",
      checked: isChecked,
      id: "".concat(labelId, "_").concat(id),
      tabIndex: -1,
      "aria-hidden": "true"
    }), (0, _preact.h)("span", {
      htmlFor: "".concat(labelId, "_").concat(id)
    }, title)) : (0, _preact.h)("div", {
      className: "dropdown-selector__item__label",
      "aria-label": title
    }, imageUrl && (0, _preact.h)("img", {
      src: (0, _absoluteUrlRuntime.resolveUrl)(imageUrl),
      alt: title,
      className: "dropdown-selector__item-image"
    }), title), hasChildren && onToggleCollapse && collapsed !== undefined && (0, _preact.h)("div", {
      role: "button",
      tabIndex: 0,
      className: "dropdown-selector__item__collapse",
      onClick: handleCollapseClick,
      onKeyDown: handleCollapseKeyDown,
      "aria-label": title
    }, collapsed ? (0, _preact.h)(_ChevronDown.default, null) : (0, _preact.h)(_ChevronUp.default, null))), hasChildren && (0, _preact.h)(NestedDropdown, {
      labelId: labelId,
      items: children,
      onSelectItem: onSelectItem,
      onMultiSelect: onMultiSelect,
      onToggleCollapse: onToggleCollapse,
      depth: depth + 1,
      isCollapsed: collapsed,
      selectedItems: selectedItems,
      isCategoryDropdown: isCategoryDropdown,
      showBothCheckboxAndCollapse: showBothCheckboxAndCollapse
    }));
  }));
};

var _default = NestedDropdown;
exports.default = _default;